import { AccessLevel } from "../types";

export const getPrimaryAccessLevel = (accessLevels?: AccessLevel[]): AccessLevel | undefined => {
  if (!accessLevels) {
    return undefined;
  }

  if (accessLevels.includes(AccessLevel.Owner)) {
    return AccessLevel.Owner;
  }

  if (accessLevels.includes(AccessLevel.User)) {
    return AccessLevel.User;
  }

  return undefined;
};
